// src/app/modules/ThreatAlerts/database/column-formatters/StatusColumnFormatter.jsx
import React from "react";
import { CheckCircle, XCircle, Clock } from "lucide-react";

const STATUS_CONFIG = {
  active: { label: "Active", pill: "sety-pill-red", icon: XCircle },
  suspended: { label: "Suspended", pill: "sety-pill-amber", icon: XCircle },
  pending: { label: "Pending", pill: "sety-pill-purple", icon: Clock },
  acknowledged: { label: "Acknowledged", pill: "sety-pill-purple", icon: CheckCircle },
  resolved: { label: "Resolved", pill: "sety-pill-green", icon: CheckCircle },
};

export function StatusColumnFormatter(cellContent, row) {
  const config = STATUS_CONFIG[row.status] || STATUS_CONFIG.pending;
  const Icon = config.icon;

  return (
    <span className={`sety-pill ${config.pill}`}>
      <Icon size={12} />{config.label}
    </span>
  );
}
